/* Modulo — Best Sellers rail.
   Native scroll-snap does the scrolling (it swipes correctly before this file
   loads, so there is no CLS). JS only wires the arrows, the disabled states,
   and the sliding progress thumb. */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  /* The <script> tag lives inside the section, so two Best Sellers sections on
     one page execute this file twice. Without this guard that means two window
     resize listeners. boot() below still finds every instance. */
  if (window.__moduloBsLoaded) return;
  window.__moduloBsLoaded = true;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function stepSize(rail) {
    var card = rail.querySelector('.modulo-bs__card');
    if (!card) return rail.clientWidth * 0.8;
    var cs = getComputedStyle(rail);
    var gap = parseFloat(cs.columnGap || cs.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  /* Sliding window: the thumb's width is the fraction of the rail in view and
     it travels left→right, so every arrow click visibly advances it.
     translateX(%) resolves against the thumb's OWN width, hence the /w. */
  function updateProgress(rail, thumb, rtl) {
    if (!thumb) return;
    var scrollW = rail.scrollWidth;
    var clientW = rail.clientWidth;
    var max = scrollW - clientW;
    var visible = scrollW > 0 ? clientW / scrollW : 1;
    var w = Math.max(0.12, Math.min(1, visible));
    var pct = max > 2 ? Math.abs(rail.scrollLeft) / max : 0;
    var tx = w < 1 ? pct * (1 - w) / w * 100 : 0;
    thumb.style.width = (w * 100) + '%';
    /* translateX is NOT direction-aware — positive X is always physically
       rightward. The thumb is anchored with inset-inline-start, so in RTL it
       starts at the physical right and must travel negative. Without this the
       indicator is mirrored against the content it describes. */
    thumb.style.transform = 'translateX(' + (rtl ? -tx : tx) + '%)';
  }

  function updateArrows(rail, prev, next) {
    var max = rail.scrollWidth - rail.clientWidth;
    /* abs() because RTL scrollLeft runs 0 → -max. Without it, prev would be
       permanently disabled and next permanently enabled in RTL. */
    var pos = Math.abs(rail.scrollLeft);
    var active = document.activeElement;
    if (prev) prev.disabled = pos <= 2;
    if (next) next.disabled = pos >= max - 2;
    /* Reaching an end disables the very button being clicked, which drops focus
       to <body> mid-interaction. Hand it to the sibling instead. */
    if (active === prev && prev.disabled && next && !next.disabled) next.focus();
    else if (active === next && next.disabled && prev && !prev.disabled) prev.focus();
  }

  function initSection(section) {
    if (section.__moduloBsInit) return;
    section.__moduloBsInit = true;

    var rail = section.querySelector('[data-modulo-bs-rail]');
    if (!rail) return;

    var thumb = section.querySelector('[data-modulo-bs-thumb]');
    var prev = section.querySelector('[data-modulo-bs-prev]');
    var next = section.querySelector('[data-modulo-bs-next]');
    var rtl = getComputedStyle(rail).direction === 'rtl';

    function sync() {
      updateArrows(rail, prev, next);
      updateProgress(rail, thumb, rtl);
    }

    function page(dir) {
      var s = stepSize(rail);
      /* Advance a full viewport of cards. The max(1,…) floor matters: when one
         card is wider than the rail (mobile peek), floor() gives 0 and the
         arrows would silently do nothing. */
      var perClick = Math.max(1, Math.floor(rail.clientWidth / s));
      rail.scrollBy({
        left: dir * s * perClick * (rtl ? -1 : 1),
        behavior: REDUCE ? 'auto' : 'smooth'
      });
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    /* Leading-edge throttle — one call per frame, fired continuously. A
       cancel-and-reschedule debounce would only update at the END of a smooth
       scroll and the thumb would jump instead of glide. */
    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        sync();
        ticking = false;
      });
    }, { passive: true });

    /* Exposed for the single shared resize handler below — a per-instance
       window listener would pin every re-rendered editor section in memory. */
    rail._bsSync = sync;
    sync();
  }

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-bs]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var rails = document.querySelectorAll('[data-modulo-bs-rail]');
      for (var i = 0; i < rails.length; i++) {
        if (rails[i]._bsSync) rails[i]._bsSync();
      }
    }, 100);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
